import React, { useState } from 'react';
import axios from 'axios';

const HospitalRegisterModal = () => {
  // --- STATE ---
  const [formData, setFormData] = useState({
    name: '',            // Hospital Name
    email: '',           // Official Email
    password: '',
    phone: '',           // Reception/Admin Phone
    city: '',
    address: '',         // Physical Location
    licenseNumber: '',   // Crucial for verification
    website: ''          // Optional
  });

  const [loading, setLoading] = useState(false);

  // --- HANDLERS ---
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // NOTE: We will create this backend route next
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/users/register-hospital", formData);

      if (res.data.status === 'ok') {
        alert('Hospital Registration Successful! Please Login to access the Verification Console.');

        // Close Modal
        document.getElementById('hospitalRegisterModalCloseBtn').click();

        // Reset Form
        setFormData({
          name: '', email: '', password: '', phone: '',
          city: '', address: '', licenseNumber: '', website: ''
        });
      }
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || 'Registration Failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal fade" id="hospitalRegisterModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content border-0 shadow-lg">

          {/* --- HEADER --- */}
          <div className="modal-header text-white" style={{ background: '#0d6efd' }}>
            <h5 className="modal-title fw-bold d-flex align-items-center">
              <i className="bi bi-hospital fs-3 me-2"></i> Partner Hospital Registration
            </h5>
            <button type="reset" id="hospitalRegisterModalCloseBtn" className="btn-close btn-close-white shadow-none" data-bs-dismiss="modal"></button>
          </div>

          {/* --- BODY --- */}
          <div className="modal-body p-4 bg-light">
            <div className="alert alert-primary d-flex align-items-center mb-4" role="alert">
              <i className="bi bi-shield-check fs-4 me-2"></i>
              <div className="small">
                Registering as a partner allows you to <strong>Scan & Verify</strong> DDoctor Gold Cards instantly.
              </div>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="row g-3">

                {/* LEFT COLUMN: IDENTITY */}
                <div className="col-md-6">
                  <h6 className="text-muted fw-bold mb-3 small text-uppercase">Organization Details</h6>

                  <div className="mb-3">
                    <label className="form-label small fw-bold">Hospital Name</label>
                    <input type="text" name="name" className="form-control shadow-sm" placeholder="e.g. Shifa International" required value={formData.name} onChange={handleChange} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label small fw-bold">License / Reg Number</label>
                    <input type="text" name="licenseNumber" className="form-control shadow-sm" placeholder="Govt. Registration ID" required value={formData.licenseNumber} onChange={handleChange} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label small fw-bold">Official Website (Optional)</label>
                    <input type="url" name="website" className="form-control shadow-sm" placeholder="https://..." value={formData.website} onChange={handleChange} />
                  </div>
                </div>

                {/* RIGHT COLUMN: CONTACT & SECURITY */}
                <div className="col-md-6">
                  <h6 className="text-muted fw-bold mb-3 small text-uppercase">Contact & Login</h6>

                  <div className="mb-3">
                    <label className="form-label small fw-bold">Official Email</label>
                    <input type="email" name="email" className="form-control shadow-sm" placeholder="admin@hospital.com" required value={formData.email} onChange={handleChange} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label small fw-bold">Password</label>
                    <input type="password" name="password" className="form-control shadow-sm" placeholder="Secure Password" required value={formData.password} onChange={handleChange} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label small fw-bold">Phone (Reception/Admin)</label>
                    <input type="text" name="phone" className="form-control shadow-sm" placeholder="051-xxxxxxx" required value={formData.phone} onChange={handleChange} />
                  </div>
                </div>

                {/* FULL WIDTH: LOCATION */}
                <div className="col-12">
                  <hr className="text-muted my-2" />
                  <h6 className="text-muted fw-bold mb-3 small text-uppercase">Location</h6>
                </div>

                <div className="col-md-4">
                  <label className="form-label small fw-bold">City</label>
                  <select name="city" className="form-select shadow-sm" required value={formData.city} onChange={handleChange}>
                    <option value="">Select City</option>
                    <option value="Islamabad">Islamabad</option>
                    <option value="Rawalpindi">Rawalpindi</option>
                    <option value="Lahore">Lahore</option>
                    <option value="Karachi">Karachi</option>
                    <option value="Peshawar">Peshawar</option>
                  </select>
                </div>

                <div className="col-md-8">
                  <label className="form-label small fw-bold">Full Address</label>
                  <input type="text" name="address" className="form-control shadow-sm" placeholder="Sector / Street Address" required value={formData.address} onChange={handleChange} />
                </div>

              </div>

              {/* --- SUBMIT BUTTON --- */}
              <div className="mt-4">
                <button
                  type="submit"
                  className="btn btn-primary w-100 py-3 fw-bold shadow"
                  disabled={loading}
                >
                  {loading ? 'Registering...' : 'Register as Hospital Partner'}
                </button>
                <p className="text-center text-muted small mt-2">
                  By registering, you agree to the DDoctor Partner Terms of Service.
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HospitalRegisterModal;